// extracted by mini-css-extract-plugin
export var box = "_9f-1";
export var checkboxRow = "_9f-8";
export var checked = "_9f-2";
export var descriptionSpacer = "_9f-a";
export var disabled = "_9f-3";
export var icon = "_9f-6";
export var input = "_9f-0";
export var labelSpacer = "_9f-9";
export var medium = "_9f-5";
export var small = "_9f-4";
export var text = "_9f-7";